module.exports = __webpack_public_path__ + "img/zx8.6fdda79e.png";